import { create } from 'zustand';

import { EEventInfoKey } from '@components/detail-panel/components/EventInfoCard/typed';
import { IFrontendGeneratedFields } from '@components/mapped-event-management/store';
import { MappedEvent } from '@src/emp-3.0/types/mapped-event';

export interface IMappedEventData extends MappedEvent, IFrontendGeneratedFields {}

interface IMappedDetailPanelStore {
  mappedEventData?: IMappedEventData;
  mappedEventDataDraft?: IMappedEventData;
  setMappedEventData: (mappedEventData: IMappedEventData) => void;
  setMappedEventDataDraft: (mappedEventData: IMappedEventData) => void;
  setMappedEventInfo: (key: EEventInfoKey, value?: string) => void;
  resetMappedDetailPanelStore: () => void;
}

export const useMappedDetailPanelStore = create<IMappedDetailPanelStore>((set, get) => ({
  mappedEventData: undefined,
  mappedEventDataDraft: undefined,
  setMappedEventData: (mappedEventData) => set(() => ({ mappedEventData })),
  setMappedEventDataDraft: (mappedEventDataDraft) => set(() => ({ mappedEventDataDraft })),
  setMappedEventInfo: (key, value) => {
    const setMappedEventDataDraft = get().setMappedEventDataDraft;
    let mappedEvent = get().mappedEventDataDraft;
    if (mappedEvent) {
      mappedEvent = {
        ...mappedEvent,
        [key]: value,
      };
      setMappedEventDataDraft(mappedEvent);
    }
  },
  resetMappedDetailPanelStore: () =>
    set(() => ({
      mappedEventData: undefined,
      mappedEventDataDraft: undefined,
    })),
}));
